import axios from "axios";
const { natus_env } = require("../config");

export default axios.create({
   baseURL:
    natus_env == "production"
      ? "https://veterinaryapi.petinoks.com/api/"
      : "https://veterinaryapi-uat.petinoks.com/api/",
//  baseURL: "https://localhost:44317/api",
  headers: {
    "access-control-allow-headers": "content-type",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json ",
    Authorization: "Bearer " + localStorage.natusToken,
  },
});
